// The server remains authoritative. These capabilities keep pickers and actions
// consistent with the policy without reproducing its matching rules in the UI.
const catalogIndexes = new WeakMap();
function catalogIndex(items) {
  if (!catalogIndexes.has(items)) catalogIndexes.set(items, new Map(items.map((item) => [String(item.id), item])));
  return catalogIndexes.get(items);
}

export function canUseStockLocation(context, form, action, locationId) {
  if (context.permissions?.[action] === false) return false;
  if (form.permissions_by_location?.[locationId]?.[action] === false) return false;
  const location = context.locations.find((entry) => String(entry.id) === String(locationId));
  if (location?.[`can_${action}`] === false) return false;
  return (form.lines || []).every((line) => {
    const item = catalogIndex(context.items).get(String(line.item_id));
    return item?.permissions_by_location?.[locationId]?.[action] !== false;
  });
}

export function canActOnStockRequisition(context, form, action) {
  if (context.permissions?.[action] === false || form.permissions?.[action] === false) return false;
  if (form.source_location_id) return canUseStockLocation(context, form, action, form.source_location_id);
  return action === "request" && context.locations.some((location) => canUseStockLocation(context, form, action, location.id));
}
